import React from "react";
import ErrorPage from "../ErrorPage";
import { work } from "../../../images";

const NoTableData = (props) => {
  const { title } = props;

  const intentMessage = title ? `'${title}'.` : "";

  return (
    <ErrorPage
      title="No Record Available"
      description="It appears that there is no data available in our records"
      intent={`${intentMessage}`}
      img={work}
    />
  );
};

export default NoTableData;
